import React, { Component } from 'react';
import { Icon, Button } from 'react-materialize';
import Loader from 'react-loader-spinner';

import SavedSearch from './SavedSearch';

import './SavedSearchesSidebar.css';

class SavedSearchesSidebar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      savedSearches: {
        test: {
          ecm_fulltext: null,
          queryParams: "archive_submission:application = \"BA\" and archive_submission:artProgram = \"Custom Art\" and archive_submission:character = \" Batman\""
        },
        test_1: {
          ecm_fulltext: null,
          queryParams: "archive_submission:application = \"BA\" and archive_submission:artProgram = \"Custom Art\" and archive_submission:character = \" Batman\""
        },
        test_2: {
          ecm_fulltext: null,
          queryParams: "archive_submission:application = \"BA\" and archive_submission:artProgram = \"Custom Art\" and archive_submission:character = \" Batman\""
        }
      }
    };

    this._handleSearchDelete = this._handleSearchDelete.bind(this);
    this._handleRefreshClick = this._handleRefreshClick.bind(this);
  }

  get savedSearches() {
    return this.state.savedSearches;
  }

  set savedSearches(savedSearches) {
    this.setState({ savedSearches:  savedSearches });
  }

  _handleSearchDelete(event) {
    
  }

  _handleRefreshClick(event) {

  }

  render() {
    const { loading, savedSearches } = this.state;
    const { hidden } = this.props;

    return (
      <aside className="saved-searches-sidebar" style={ hidden ? { right: '-350px' } : {} }>
        <div className="loading-panel" hidden={ !loading }>
          <Loader type="TailSpin" color="rgb(56, 56, 56)" height={ 40 } width={ 40 }/>
        </div>
        <div id="container">
          <div className="content">
            <div className="items-list">
              { 
                Object.keys(savedSearches)
                  .map((savedSearchName,id) => {
                    return (<SavedSearch key={id} name={ savedSearchName } data={ savedSearches[savedSearchName] } onDelete={ this._handleSearchDelete } />);
                })
              }
            </div>
            <div className="toolbar">
              <div className="actions">
                <div className="layout horizontal">
                  <Button waves='light' style={{ fontSize: '10px' }} onClick={ this._handleRefreshClick }>
                    Refresh
                    <Icon left>autorenew</Icon>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </aside>
    );
  }
}

export default SavedSearchesSidebar;
